import { useState, type FormEvent } from "react";
import { submitForm } from "@/utils/formSubmit";

const subjects = ["投稿二创 / 表情包", "内容纠错", "推荐一个梗", "商务合作", "其他问题"];

export default function ContactForm() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [messageLength, setMessageLength] = useState(0);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    setSubmitting(true);
    const result = await submitForm(form);
    setSubmitting(false);
    if (result.ok) {
      setStatus("success");
      setFormError("");
      setMessageLength(0);
      form.reset();
    } else {
      setStatus("error");
      setFormError(result.message);
    }
  };

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8" aria-labelledby="contact-form-title">
      <h2 id="contact-form-title" className="text-xl text-foreground-950 md:text-2xl">
        给我们留言
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-foreground-600">
        带 * 的为必填项。投稿类留言请附上作品链接，方便编辑快速查看。
      </p>

      <form
        id="contact-page-form"
        data-readdy-form
        action="https://readdy.ai/api/form/daio2vbp14a1h3mr780g"
        method="post"
        onSubmit={handleSubmit}
        className="mt-6 space-y-5"
      >
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <div>
            <label htmlFor="contact-name" className="mb-1.5 block font-label text-sm text-foreground-800">
              昵称 <span className="text-primary-500">*</span>
            </label>
            <input
              id="contact-name"
              type="text"
              name="name"
              required
              autoComplete="name"
              placeholder="怎么称呼你"
              className="w-full rounded-md border border-background-300 bg-background-100 px-3 py-2.5 font-label text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50 focus:outline-none"
            />
          </div>
          <div>
            <label htmlFor="contact-email" className="mb-1.5 block font-label text-sm text-foreground-800">
              邮箱 <span className="text-primary-500">*</span>
            </label>
            <input
              id="contact-email"
              type="email"
              name="email"
              required
              autoComplete="email"
              placeholder="用于接收回复"
              className="w-full rounded-md border border-background-300 bg-background-100 px-3 py-2.5 font-label text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50 focus:outline-none"
            />
          </div>
        </div>

        <div>
          <label htmlFor="contact-subject" className="mb-1.5 block font-label text-sm text-foreground-800">
            咨询类型 <span className="text-primary-500">*</span>
          </label>
          <select
            id="contact-subject"
            name="subject"
            required
            defaultValue={subjects[0]}
            className="w-full rounded-md border border-background-300 bg-background-100 px-3 py-2.5 font-label text-sm text-foreground-900 focus:border-primary-400 focus:outline-none"
          >
            {subjects.map((subject) => (
              <option key={subject} value={subject}>
                {subject}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label htmlFor="contact-message" className="mb-1.5 block font-label text-sm text-foreground-800">
            留言内容 <span className="text-primary-500">*</span>
          </label>
          <textarea
            id="contact-message"
            name="message"
            required
            rows={5}
            maxLength={500}
            onChange={(event) => setMessageLength(event.target.value.length)}
            placeholder="简单说说你想沟通的事情，投稿请附上链接，最多 500 字。"
            className="w-full resize-none rounded-md border border-background-300 bg-background-100 px-3 py-2.5 font-label text-sm leading-relaxed text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50 focus:outline-none"
          />
          <p className={`mt-1.5 text-right text-xs ${messageLength >= 500 ? "text-primary-600" : "text-foreground-400"}`}>
            {messageLength} / 500
          </p>
        </div>

        <input
          type="text"
          name="website_alt"
          className="field-guard-alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />

        <div className="flex flex-wrap items-center gap-4">
          <button
            type="submit"
            disabled={submitting}
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <i className="ri-send-plane-line" aria-hidden="true"></i>
            {submitting ? "提交中…" : "提交留言"}
          </button>
          {status === "success" ? (
            <p className="text-sm text-secondary-700" role="status">
              提交成功，我们会在 1-2 个工作日内回复你。
            </p>
          ) : null}
          {status === "error" ? (
            <p className="text-sm text-primary-600" role="alert">
              {formError}
            </p>
          ) : null}
        </div>
      </form>
    </section>
  );
}